module.exports = __webpack_public_path__ + "static/media/empty-explore.98cc7829.png";